import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const KEY = "kb_cart";
const COUPON_KEY = "kb_coupon";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);
  const [coupon, setCoupon] = useState(() => {
    try { return JSON.parse(localStorage.getItem(COUPON_KEY)) || null; } catch { return null; }
  });
  useEffect(() => localStorage.setItem(KEY, JSON.stringify(items)), [items]);
  useEffect(() => {
    if (coupon) localStorage.setItem(COUPON_KEY, JSON.stringify(coupon));
    else localStorage.removeItem(COUPON_KEY);
  }, [coupon]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const commercial = Object.fromEntries(["selling_unit", "selling_unit_label_en", "selling_unit_label_fr"].map(k => [k, product[k] || ""]));
      const found = prev.find((i) => i.product_id === product.id);
      if (found)
        return prev.map((i) => (i.product_id === product.id ? { ...i, ...commercial, quantity: i.quantity + qty } : i));
      return [...prev, {
        product_id: product.id, slug: product.slug, quantity: qty, ...commercial,
        name_fr: product.name_fr, name_en: product.name_en,
        price: product.sale_price || product.price,
        image: (product.images || [])[0] || "",
        weight: product.weight || "",
      }];
    });
    setOpen(true);
  };
  const updateQty = (id, qty) =>
    setItems((prev) => prev.map((i) => (i.product_id === id ? { ...i, quantity: Math.max(1, qty) } : i)));
  const removeItem = (id) => setItems((prev) => prev.filter((i) => i.product_id !== id));
  const clear = () => { setItems([]); setCoupon(null); };

  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);
  const subtotal = useMemo(() => items.reduce((s, i) => s + i.price * i.quantity, 0), [items]);
  const applyCoupon = (code, discount) => setCoupon({ code, discount });
  const clearCoupon = () => setCoupon(null);

  return (
    <CartContext.Provider value={{
      items, addItem, updateQty, removeItem, clear, count, subtotal, open, setOpen,
      coupon, applyCoupon, clearCoupon,
    }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
